"use strict";

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", { value: true });
var InlineEditDataType = /** @class */function () {
    function InlineEditDataType() {}
    /**
     * @inheritdoc
     */
    InlineEditDataType.prototype.formatInput = function (cell, value) {
        return value;
    };
    /**
     * @inheritdoc
     */
    InlineEditDataType.prototype.postProcessInput = function (cell) {};
    /**
     * @inheritdoc
     */
    InlineEditDataType.prototype.formatView = function (cell, value) {
        return value;
    };
    /**
     * @inheritdoc
     */
    InlineEditDataType.prototype.formatValue = function (cell, value) {
        return value;
    };
    return InlineEditDataType;
}();
exports.InlineEditDataType = InlineEditDataType;
/**
 * String type
 */
var InlineEditString = /** @class */function (_super) {
    __extends(InlineEditString, _super);
    function InlineEditString() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "string";
        return _this;
    }
    /**
     * @inheritdoc
     */
    InlineEditString.prototype.formatInput = function (cell, value) {
        return "<input class=\"form-control dt-focus dt-input\" value=\"" + value + "\"/>";
    };
    return InlineEditString;
}(InlineEditDataType);
exports.InlineEditString = InlineEditString;
/**
 * Number type
 */
var InlineEditNumber = /** @class */function (_super) {
    __extends(InlineEditNumber, _super);
    function InlineEditNumber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "number";
        return _this;
    }
    /**
     * @inheritdoc
     */
    InlineEditNumber.prototype.formatInput = function (cell, value) {
        return "<input class=\"form-control dt-focus dt-input\" type=\"number\" value=\"" + value + "\"/>";
    };
    return InlineEditNumber;
}(InlineEditDataType);
exports.InlineEditNumber = InlineEditNumber;
/**
 * Boolean type
 */
var InlineEditBoolean = /** @class */function (_super) {
    __extends(InlineEditBoolean, _super);
    function InlineEditBoolean() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "boolean";
        return _this;
    }
    /**
     * @inheritdoc
     */
    InlineEditBoolean.prototype.formatInput = function (cell, value) {
        return "<div class=\"custom-control custom-checkbox custom-control-inline\">\n                    <input type=\"checkbox\" id=\"edit_check\" class=\"custom-control-input dt-input\"\n                          " + (value === "True" ? "checked" : "") + " value=\"true\" >\n                    <label class=\"custom-control-label\" for=\"edit_check\"></label>\n                </div>";
    };
    /**
     * @inheritdoc
     */
    InlineEditBoolean.prototype.formatValue = function (cell, value) {
        var $cell = $(cell);
        var $input = $cell.find(".dt-input");
        return $input.prop("checked") ? "True" : "False";
    };
    /**
     * @inheritdoc
     */
    InlineEditBoolean.prototype.formatView = function (cell, value) {
        var $cell = $(cell);
        var $input = $cell.find(".dt-input");
        return "<div class=\"custom-control custom-checkbox custom-control-inline\">\n                <input type=\"checkbox\" id=\"edit_check\" class=\"custom-control-input\" " + ($input.prop("checked") ? "checked" : "") + " disabled>\n                <label class=\"custom-control-label\" for=\"edit_check\"></label>\n            </div>";
    };
    return InlineEditBoolean;
}(InlineEditDataType);
exports.InlineEditBoolean = InlineEditBoolean;
/**
 * Dropdown type
 */
var InlineEditSelect2 = /** @class */function (_super) {
    __extends(InlineEditSelect2, _super);
    function InlineEditSelect2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "select2";
        return _this;
    }
    /**
     * @inheritdoc
     */
    InlineEditSelect2.prototype.formatInput = function (cell, value) {
        var $cell = $(cell);
        var url = $cell.data("url");
        var text = $cell.data("text") || "";
        var source = $cell.data("source");
        var input = "<select class=\"form-control select2 dt-input\" " + (url ? "data-ajax--url=\"" + url + "\"" : "") + " data-width=\"auto\" data-dropdown-auto-width=\"true\">";
        if (url) {
            input = input + ("<option value=\"" + value + "\"> " + (text || value) + " </option>");
        } else {
            $.map(source, function (s) {
                input = input + ("<option " + (s.value ? "data-value-string=\"" + s.value + "\"" : "") + " value=\"" + s.id + "\" " + (s.css ? "class=\"" + s.css + "\"" : "") + " " + (s.id == value ? "selected" : "") + "> " + (s.text || s.id) + " </option>");
            });
        }
        return input + "</select>";
    };
    /**
     * @inheritdoc
     */
    InlineEditSelect2.prototype.postProcessInput = function (cell) {
        var $cell = $(cell);
        var $select = $cell.find("select.select2");
        var fnData = $cell.data("select2-data");
        var data = fnData ? $[fnData] ? $[fnData]($select) : fnData : "";
        $select.select2(data);
    };
    /**
     * @inheritdoc
     */
    InlineEditSelect2.prototype.formatView = function (cell, value) {
        var $cell = $(cell);
        var data = $cell.find("select.select2").select2("data");
        var fnFormatData = $cell.data("format-view-data");
        var formatData = fnFormatData && $[fnFormatData] ? $[fnFormatData](data) : null;
        return formatData || data[0].text;
    };
    /**
     * @inheritdoc
     */
    InlineEditSelect2.prototype.formatValue = function (cell, value) {
        var $cell = $(cell);
        var data = $cell.find("select.select2").select2("data");
        return data[0].id;
    };
    return InlineEditSelect2;
}(InlineEditDataType);
exports.InlineEditSelect2 = InlineEditSelect2;


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Datatable/InlineEditDataType.ts
// module id = 524
// module chunks = 0